import SrPopover from "./SrPopover.vue";

SrPopover.install = function(Vue) {
  Vue.component(SrPopover.name, SrPopover);
};

export default SrPopover;


// WEBPACK FOOTER //
// ./packages/SrPopover/index.js